import React, { useEffect } from 'react';
import { PageContent } from '../../../shared/components/ui';
import { ResumeFooter } from './index';
import { BubbleNavigatorContainer, BubbleNavigator } from '../../../shared/components/ui/atoms';
import { QuestionaryContent } from './QuestionaryContent';
import { FormValues, SelectedIndexData } from '../../../types';
import { ONBOARDING_STEPS } from '../../../utils/constants';

interface BackgroundContainerProps {
  currentStep: number;
  selectedIndexData: SelectedIndexData;
  setSelectedIndexData: (data: SelectedIndexData) => void;
  selectedIndex: number;
  setSelectedIndex: (index: number, options?: { force?: boolean }) => void;
  values: FormValues;
  setValue: (key: string, value: string | number) => void;
  setBottomValue: (value: number) => void;
  isBrokerMode: boolean;
  isProcessingTeamMode: boolean;
  isBorrowerMode: boolean;
  isResumeShown: boolean;
  isOnMixedPropertyForm: boolean;
  lastStepsContainer: React.ReactNode;
  toggleBrokerMode: () => void;
  isBrokerUser: boolean;
}

export const BackgroundContainer: React.FC<BackgroundContainerProps> = ({
  currentStep,
  selectedIndexData,
  setSelectedIndexData,
  selectedIndex,
  setSelectedIndex,
  values,
  setValue,
  setBottomValue,
  isBrokerMode,
  isProcessingTeamMode,
  isBorrowerMode,
  isResumeShown,
  isOnMixedPropertyForm,
  lastStepsContainer,
  toggleBrokerMode,
  isBrokerUser,
}) => {
  const showOnboardingFlow = !isProcessingTeamMode && !isBorrowerMode && !isBrokerUser;

  return (
    <React.Fragment>
      <PageContent
        currentStep={currentStep || 0}
        selectedIndexData={selectedIndexData}
        setSelectedIndexData={setSelectedIndexData}
        isWide={isResumeShown || isOnMixedPropertyForm || isProcessingTeamMode || isBorrowerMode}
      >
        {showOnboardingFlow ? (
          <QuestionaryContent
            selectedIndex={selectedIndex}
            setSelectedIndex={setSelectedIndex}
            values={values}
            setValue={setValue}
            setBottomValue={setBottomValue}
            isBrokerMode={isBrokerMode}
          >
            {lastStepsContainer}
          </QuestionaryContent>
        ) : (
          lastStepsContainer
        )}
      </PageContent>

      {showOnboardingFlow && (
        <>
          <BubbleNavigatorContainer>
            <BubbleNavigator
              values={values}
              selectedIndex={selectedIndex}
              setSelectedIndex={setSelectedIndex}
              quantity={ONBOARDING_STEPS.length + 1}
            />
          </BubbleNavigatorContainer>

          <div
            className={isBrokerMode ? 'broker-button selected' : 'broker-button'}
            onClick={toggleBrokerMode}
          >
            {isBrokerMode ? "I'm a borrower -->" : "I'm a broker -->"}
          </div>

          <ResumeFooter
            values={values}
            setValue={setValue}
            setSelectedIndex={setSelectedIndex}
            setSelectedIndexData={setSelectedIndexData}
            selectedIndex={selectedIndex}
            isHidden={isResumeShown || isOnMixedPropertyForm}
            hideLastStep={!(selectedIndex === ONBOARDING_STEPS.length + 1)}
            isBrokerMode={isBrokerMode}
          />
        </>
      )}
    </React.Fragment>
  );
};
